import { FC, useEffect, useState } from "react";
import { PageHeadMedia } from "../../../components/layout";
import { LatestNewsWidget } from "../../../widgets/news/LatestNews";
import { useConfiguration } from "../../../hooks/useConfiguration";
import { TeamContext } from "../../../types/common";

const NewsItemPage: FC = () => {
    const config = useConfiguration();

    useEffect(() => {

    }, []);


    let relatedCategory;

    if (config.teamName === TeamContext.RODINA_2) {
        relatedCategory = 8;
    } else if (config.teamName === TeamContext.RODINA_M) {
        relatedCategory = 6;
    }

    const match = globalThis?.location?.pathname?.match(/\/news\/(\d+)-/);

    const newsId = match?.[1] || -1;

    return (
        <div>
            <PageHeadMedia
                mediaUrl=""
            />
            <LatestNewsWidget
                category={relatedCategory}
                newsId={+newsId}
            />
        </div>
    )
}

export default NewsItemPage;